'use strict';

angular.module('PrintixEventService', [])

  .constant('EventServiceEvents', {
    CHANNELS: {
      ALL_TENANT_ADMINS: {
        CHANNEL_NAME: 'TENANT_ADMIN',
        EVENTS: {
          AUDIT_EVENT_CREATED: 'audit_event_created',
          CREDIT_CARD_CHARGE_CREATED: 'credit_card_charge_created',
          CREDIT_CARD_CHARGE_DELETED: 'credit_card_charge_deleted',
          CREDIT_CARD_CHARGE_UPDATED: 'credit_card_charge_updated',
          DESTINATION_PROFILE_CREATED: 'destination_profile_created',
          DESTINATION_PROFILE_DELETED: 'destination_profile_deleted',
          DESTINATION_PROFILE_UPDATED: 'destination_profile_updated',
          EXTRACT_COMPLETED: 'extract_completed',
          EXTRACT_STARTED: 'extract_started',
          GROUP_ADDED: 'group_added',
          GROUP_REMOVED: 'group_removed',
          GROUPS_SYNCHRONIZATION_COMPLETE: 'groups_synchronization_complete',
          GROUPS_SYNCHRONIZATION_STARTED: 'groups_synchronization_started',
          IDENTITY_PROVIDER_CREATED: 'identity_provider_created',
          IDENTITY_PROVIDER_DELETED: 'identity_provider_deleted',
          IDENTITY_PROVIDER_ERROR: 'identity_provider_error',
          IDENTITY_PROVIDER_UPDATED: 'identity_provider_updated',
          IDENTITY_PROVIDER_WARNING: 'identity_provider_warning',
          INVITE_ADDED: 'invite_added',
          INVITE_REMOVED: 'invite_removed',
          NETWORK_ADDED: 'network_added',
          NETWORK_CHANGED: 'network_changed',
          NETWORK_REMOVED: 'network_removed',
          PRINT_RULE_CONFIGURATION_CREATED: 'print_rule_configuration_added',
          PRINT_RULE_CONFIGURATION_UPDATED: 'print_rule_configuration_updated',
          QUEUE_DRIVER_CONFIG_CHANGED: 'queue_driver_config_changed',
          TASK_PROGRESS_ADMIN: 'task_progress_admin',
          TENANT_CLOUD_STORE_ACCOUNT_CREATED: 'tenant_cloud_store_account_created',
          TENANT_CLOUD_STORE_ACCOUNT_DELETED: 'tenant_cloud_store_account_deleted',
          TENANT_CLOUD_STORE_ACCOUNT_UPDATED: 'tenant_cloud_store_account_updated',
          TENANT_ISSUE_CREATED: 'tenant_issue_created',
          TENANT_ISSUE_DELETED: 'tenant_issue_deleted',
          TENANT_ISSUE_UPDATED: 'tenant_issue_updated',
          TENANT_ONDEVICE_CONFIG_CREATED: 'tenant_ondevice_config_created',
          TENANT_ONDEVICE_CONFIG_DELETED: 'tenant_ondevice_config_deleted',
          TENANT_ONDEVICE_CONFIG_UPDATED: 'tenant_ondevice_config_updated',
          TENANT_PRINTER_CREDENTIAL_CREATED: 'tenant_printer_credential_created',
          TENANT_PRINTER_CREDENTIAL_DELETED: 'tenant_printer_credential_deleted',
          TENANT_SITE_CREATED: 'tenant_site_created',
          TENANT_SITE_DELETED: 'tenant_site_deleted',
          TENANT_SITE_UPDATED: 'tenant_site_updated',
          TODO_REMOVED: 'todo_removed',
          UNKNOWN_NETWORK_LIST_BUILT: 'unknown_network_list_built',
          UNKNOWN_NETWORK_LIST_UPDATED: 'unknown_network_list_updated',
          USER_ADDED: 'user_added',
          USER_REMOVED: 'user_removed',
          USER_UPDATED: 'user_updated',
          WORKFLOW_CREATED: 'workflow_created',
          WORKFLOW_DELETED: 'workflow_deleted',
          WORKFLOW_UPDATED: 'workflow_updated',
          WORKSTATION_ADDED: 'workstation_added',
          WORKSTATION_ONTENANTNETWORK_CHANGED: 'workstation_onTenantNetwork_changed',
          WORKSTATION_QUEUE_ADDED: 'workstation_queue_added',
          WORKSTATION_QUEUE_CHANGED: 'workstation_queue_changed',
          WORKSTATION_QUEUE_REMOVED: 'workstation_queue_removed',
          WORKSTATION_QUEUES_CHANGED: 'workstation_queues_changed',
          WORKSTATION_REMOVED: 'workstation_removed',
          WORKSTATION_STATS_UPDATED: 'ws_stats_updated',
          WORKSTATION_TASK_ADDED: 'ws_task_added',
          WORKSTATION_TASK_REMOVED: 'ws_task_removed',
          WORKSTATION_TASK_STATUS_CHANGED: 'ws_task_status_changed',
          WORKSTATION_UPDATED: 'workstation_updated'
        }
      },

      ALL_TENANT_USERS: {
        CHANNEL_NAME: 'TENANT_USER',
        EVENTS: {
          AUTH_CONFIG_UPDATED: 'auth_config_updated',
          BATCH_EXECUTED: 'batch_executed',
          BILLING_DATA_UPDATED: 'billing_data_updated',
          PRINT_QUEUE_ADDED: 'print_queue_added',
          PRINT_QUEUE_GROUPS_UPDATED: 'print_queue_groups_updated',
          PRINT_QUEUE_REMOVED: 'print_queue_removed',
          PRINT_QUEUE_UPDATED: 'print_queue_updated',
          PRINTER_ADDED: 'printer_added',
          PRINTER_CREATION_UPDATE: 'printer_creation_update',
          PRINTER_REMOVED: 'printer_removed',
          PRINTER_STATUS_UPDATE: 'printer_status_update',
          PRINTER_UPDATE: 'printer_updated',
          SECURE_PRINT_CONFIGURATION_ADDED: 'secure_print_configuration_added',
          SECURE_PRINT_CONFIGURATION_REMOVED: 'secure_print_configuration_removed',
          SECURE_PRINT_CONFIGURATION_UPDATED: 'secure_print_configuration_updated',
          SNMP_CONFIGURATION_CREATED: 'snmp_configuration_created',
          SNMP_CONFIGURATION_DELETED: 'snmp_configuration_deleted',
          SNMP_CONFIGURATION_UPDATED: 'snmp_configuration_updated',
          TENANT_UPDATED: 'tenant_updated',
          WORKSTATION_NETWORK_CHANGED: 'workstation_network_changed'
        }
      },
      SPECIFIC_USER: {
        CHANNEL_NAME: 'USER',
        EVENTS: {
          DISCOVERY_REPORT: 'discovery_report',
          JOB_ADDED: 'job_added',
          JOB_REMOVED: 'job_removed',
          JOB_STATE_CHANGED: 'job_state_changed',
          TASK_PROGRESS_USER: 'task_progress_user'
        }
      }
    }
  })

  .constant('PrintixEventServiceConstants', {
    AUTH_ENDPOINT_SUFFIX: '/pusher/auth'
  })

  .service('EventService',
    function ($rootScope, EnvironmentService, TenantListService, $pusher, EventServiceEvents, USER_RIGHTS, PrintixEventServiceConstants) {
      const eventServicePrivate = {};
      let pusher = null;
      const eventChannels = angular.copy(EventServiceEvents.CHANNELS);
      const pusherInfoTenantKey = 'PUSHER_CLIENT_INFO';

      eventServicePrivate.startListeningForEvents = function () {
        if (TenantListService.currentTenant &&
          TenantListService.currentTenant.info &&
          TenantListService.currentTenant.info._embedded &&
          TenantListService.currentTenant.info._embedded[pusherInfoTenantKey]) {
          if ($rootScope.currentUser && !$rootScope.currentUser.info._embedded.permissions.permissions.contains(USER_RIGHTS.OPEN_ADMINISTRATOR_WEB_APP)) {
            delete eventChannels.ALL_TENANT_ADMINS;
          }

          // Pusher.logToConsole = true;

          const token = $rootScope.getAccessToken();
          const pusherConfig = {
            cluster: TenantListService.currentTenant.info._embedded[pusherInfoTenantKey].cluster,
            encrypted: true,
            authEndpoint: EnvironmentService.apiBaseUrl + PrintixEventServiceConstants.AUTH_ENDPOINT_SUFFIX,
            auth: {
              headers: {}
            }
          };
          pusherConfig.auth.headers.Authorization = 'Bearer ' + token;

          const client = new Pusher(TenantListService.currentTenant.info._embedded[pusherInfoTenantKey].key, pusherConfig);

          pusher = $pusher(client);
          angular.forEach(eventChannels, function (channel) {
            pusher.subscribe(TenantListService.currentTenant.info._embedded[pusherInfoTenantKey].channels[channel.CHANNEL_NAME]);
            angular.forEach(channel.EVENTS, function (event) {
              pusher.bind(event,
                function (data) {
                  $rootScope.$broadcast(event, data);
                }
              );
            });
          });
        }
      };

      const listener = $rootScope.$watch(function () {
        return $rootScope.currentUser;
      }, function () {
        if ($rootScope.currentUser) {
          if (TenantListService.currentTenant.info &&
            TenantListService.currentTenant.info._embedded &&
            TenantListService.currentTenant.info._embedded[pusherInfoTenantKey]) {
            listener();
            eventServicePrivate.startListeningForEvents();
          } else {
            throw new Error('EventService $watch TenantListService.currentTenant: TenantListService.currentTenant.info._embedded.PUSHER_CLIENT_INFO is missing');
          }
        }
      });

      // Handle Pusher token expire problem
      (function () {
        const proxied = window.XMLHttpRequest.prototype.open;
        window.XMLHttpRequest.prototype.open = function () {
          if (arguments[1].indexOf(PrintixEventServiceConstants.AUTH_ENDPOINT_SUFFIX) > -1) {
            if (!$rootScope.checkIfAccessTokenIsValid()) {
              $rootScope.handleEventServiceAccessTokenInvalid();
            } else {
              return proxied.apply(this, [].slice.call(arguments));
            }
          } else {
            return proxied.apply(this, [].slice.call(arguments));
          }
        };
      })();
    }
  );
